export function checkIfEventPast7Days(time: string): boolean {
  if (!time) return false;

  const givenTime = new Date(time);

  if (isNaN(givenTime.getTime())) return false;

  const currentTime = new Date();
  const sevenDaysAgo = new Date(
    currentTime.getTime() - 7 * 24 * 60 * 60 * 1000
  ); // Subtract 7 days in milliseconds

  return givenTime < sevenDaysAgo; // Return true if given time is more than 7 days old
}
